import ErrorBoundary from 'components/ErrorBoundary';
import { useConversationCategory } from 'hooks/business/conversationsHooks/useConversationCategory';
import { useOpenConversation } from 'hooks/business/conversationsHooks/useOpenConversation';

import Chat from '../Chat';
import { ChatErrorResult } from './ChatErrorResult';
import { ReactNode } from 'react';

export interface ChatSectionProps {
  conversation: Conversation.Conversation;
}

export const ChatSection = (props: ChatSectionProps) => {
  const { conversation } = props;
  const { conversationId } = conversation;
  const category = useConversationCategory();
  const openConversation = useOpenConversation();

  return (
    <ChatErrorBoundary onReset={() => openConversation(conversation, { category })}>
      {/* keyed让不同会话id执行unmount，区隔不同的converstaion直接的异步行为 */}
      <Chat
        conversationId={conversationId}
        key={`conversation-center-chat-${conversationId}`}
        showSideFoldBtn
      />
    </ChatErrorBoundary>
  );
};

export function ChatErrorBoundary({
  children,
  onReset,
}: {
  children: ReactNode;
  onReset?: () => void;
}) {
  return (
    <ErrorBoundary
      componentName="chat"
      fallback={(_, reset) => {
        return <ChatErrorResult reset={reset} onReset={onReset} />;
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
